import axios from 'axios';
import { LOCAL_STORAGE_TOKEN_KEY } from './constants';

const API = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: { Authorization: `Bearer ${localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY)}` },
});

API.interceptors.response.use(null, (error) => {
    if (!localStorage.getItem(LOCAL_STORAGE_TOKEN_KEY)) return;

    if (error.response.status === 401) {
        localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY);
        window.location.href = '/login';
    }
});

const MerchantAPI = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: { 'api-key': `ZQ9wMawSklqpvdiFdON2h9d1mJMmaLgywzqNmIENRzplPwyNPemrfmn9rbpdgCRt` },
});

MerchantAPI.interceptors.response.use(null, (error) => {
    if (error.response.status === 401) {
        localStorage.removeItem(LOCAL_STORAGE_TOKEN_KEY);
        window.location.href = '/login';
    }
});

export { MerchantAPI };

export default API;
